import React, { useEffect, useState } from "react";
import { MockStatsService } from "../../services/MockStatsService";
import { getDatasetCount } from "../../services/CkanApiService";

const StatistikPortalCompOpenData = () => {
    const [stats, setStats] = useState({
        datasetCount: 0,
        priorityDataCount: 0,
        downloadCount: 0,
        visitorCount: 0
    });

    useEffect(() => {
        const fetchStats = async () => {
            const mockStats = await MockStatsService.getGlobalStats();
            // Fetch real dataset count from CKAN
            const ckanCount = await getDatasetCount();

            setStats({
                datasetCount: ckanCount,
                priorityDataCount: mockStats.priorityDataCount,
                downloadCount: mockStats.downloadCount,
                visitorCount: mockStats.visitorCount
            });
        };
        fetchStats();
    }, []);

    return (
        <section id="features" className="features pt-5 pb-5 bg-light">
            <div className="container" data-aos="fade-up">

                {/* <div className="section-title text-center mb-5">
                    <h2 style={{ color: "#198754", fontWeight: "bold" }}>Statistik Portal Satu Data</h2>
                </div> */}

                <div className="row text-center d-flex justify-content-center">
                    {/* <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                        <div className="icon-box" style={{ background: "transparent", border: "none", boxShadow: "none" }}>
                            <div className="mb-3">
                                <img src="/img/stats/dataset.png" alt="Dataset" style={{ width: "100px", height: "100px", objectFit: "contain", background: "#f0f2f5", borderRadius: "50%", padding: "15px" }} />
                            </div>
                            <h1 style={{ color: "#198754", fontWeight: "bold" }}>{stats.datasetCount.toLocaleString('id-ID')}</h1>
                            <h4>Dataset</h4>
                            <p className="text-muted" style={{ fontSize: "14px" }}>Total seluruh dataset tersedia</p>
                        </div>
                    </div> */}
                    {/* <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                        <div className="icon-box" style={{ background: "transparent", border: "none", boxShadow: "none" }}>
                            <div className="mb-3">
                                <img src="/img/stats/prioritas.png" alt="Prioritas" style={{ width: "100px", height: "100px", objectFit: "contain", background: "#f0f2f5", borderRadius: "50%", padding: "15px" }} />
                            </div>
                            <h1 style={{ color: "#198754", fontWeight: "bold" }}>{stats.priorityDataCount.toLocaleString('id-ID')}</h1>
                            <h4>Data Prioritas</h4>
                            <p className="text-muted" style={{ fontSize: "14px" }}>Dataset prioritas di tahun ini</p>
                        </div>
                    </div> */}
                    <div className="border-dashed-right col-lg-3 col-md-4 mt-4 mt-lg-0">
                        <div className="icon-box" style={{ background: "transparent", border: "none", boxShadow: "none" }}>
                            {/* <div className="mb-3">
                                <img src="/img/stats/download.png" alt="Download" style={{ width: "100px", height: "100px", objectFit: "contain", background: "#f0f2f5", borderRadius: "50%", padding: "15px" }} />
                            </div> */}
                            <h4 style={{ color: "#198754" }}>Download</h4>
                            <h1 style={{ color: "#198754", fontWeight: "bold" }}>{stats.downloadCount.toLocaleString('id-ID')}</h1>
                            <p className="text-muted" style={{ fontSize: "14px" }}>Total data sudah di download pada portal</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                        <div className="icon-box" style={{ background: "transparent", border: "none", boxShadow: "none" }}>
                            {/* <div className="mb-3">
                                <img src="/img/stats/pengunjung.png" alt="Pengunjung" style={{ width: "100px", height: "100px", objectFit: "contain", background: "#f0f2f5", borderRadius: "50%", padding: "15px" }} />
                            </div> */}
                            <h4 style={{ color: "#198754" }}>Pengunjung</h4>
                            <h1 style={{ color: "#198754", fontWeight: "bold" }}>{stats.visitorCount.toLocaleString('id-ID')}</h1>
                            <p className="text-muted" style={{ fontSize: "14px" }}>Total data pengunjung pada portal</p>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default StatistikPortalCompOpenData;